import React from "react";

function InterviewTable({
  object,
  categories,
  descriptions,
  formState,
  handleCheckboxChange,
  isRecruiter,
}) {
  return (
    <table
      className="textwrap"
      style={{
        width: "100%",
        borderCollapse: "collapse",
        borderRadius: "12px 12px 0 0",
      }}
    >
      <thead style={{ backgroundColor: "#E09552", color: "white" }}>
        <tr>
          {categories.map((category) => (
            <th
              key={category.key}
              style={{
                textAlign: "center",
                padding: "12px",
                fontWeight: "normal",
              }}
            >
              {category.label}
            </th>
          ))}
          <th
            style={{
              textAlign: "center",
              padding: "12px",
              fontWeight: "normal",
            }}
          >
            Points
          </th>
        </tr>
      </thead>
      <tbody>
        {descriptions.map((row, rowIndex) => (
          <tr key={rowIndex}>
            {categories.map((category, colIndex) => (
              <td
                key={category.key}
                style={{
                  padding: "12px",
                  verticalAlign: "middle",
                  border: "1px solid #ddd",
                  borderLeft: "0",
                  cursor: "pointer",
                }}
                {...(isRecruiter && {
                  onClick: () => handleCheckboxChange(category.key, row.value),
                })}
                // onClick={() => handleCheckboxChange(category.key, row.value)}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <input
                    disabled={object}
                    type="radio"
                    value={row.value}
                    checked={formState[category.key] === row.value}
                    onChange={() =>
                      handleCheckboxChange(category.key, row.value)
                    }
                    style={{
                      alignSelf: "center",
                      marginLeft: "10px",
                      width: "18px",
                      height: "18px",
                      borderRadius: "50%",
                      appearance: "none",
                      border: "2px solid #ccc",
                      outline: "none",
                      cursor: "pointer",
                      backgroundColor:
                        formState[category.key] === row.value
                          ? "#E09552"
                          : "white",
                    }}
                  />
                  <span style={{ flex: "1" }}>
                    {row.text?.[colIndex] || "N/A"}
                  </span>
                </div>
              </td>
            ))}
            <td
              style={{
                textAlign: "center",
                verticalAlign: "middle",
                border: "1px solid #ddd",
                borderRight: "0",
              }}
            >
              {row.value}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default InterviewTable;
